import React from 'react';
import {HashLink as Link} from "react-router-hash-link";


const BRBizInitialTourAttestation={
        url: `/board/BreachRisk/Business/Attestations`,
        type: `tutorial`,
        user: {
            first_login: true,
        },
        entity: {
            verified_ownership: true,
            hasScores: null,
        },
        openingModal: {
            icon: null,
            heading: "Attestations Gives the Confidence of Your Promise",
            description: <div className={"text-center"}>
                <p>
                    Use the tables and forms on this page to ascertain that the full picture of your cyberspace has been added to the BreachRisk&trade; engine.
                </p>
                <p>
                    Attestations allow you to certify that you've told us all about your cyberspace landscape. When you share your BreachRisk&trade; Score or BreachRisk&trade; Report, others will see that you're confident everything has been included.
                </p>
                <p>
                    Attestations further improve the Fidelity of your score. Learn more about Fidelity and Attestations in our <Link to={`/board/userguide`}className={"text-white"}><u>Interactive User's Guide. </u></Link>
                </p>


            </div>
        },
        tourSteps:{
            1:{
                step: 1,
                title: "",
                content: "This table shows a record of attestations made by your company.",
                scrollToElement: false,
                anchorEl: "#tourAttestationsTable",
                element: null,
                last: false,
            },
            2:{
                step: 2,
                title: null,
                placement:"top-center",
                content: "Attestations allow you to improve your fidelity with your promise of confidence.",
                scrollToElement: false,
                anchorEl: "#tourAttestationsTable",
                element: null,
                last: false,
            },
            3:{
                step: 3,
                title: "New Attestation",
                content: "Be prepared—to add an attestation be ready to ascertain that your IT infrastructure— IP Addresses, Domains, and Subdomains— have all been included in your BreachRisk™ assessments.  ",
                placement: "top-end",
                scrollToElement: false,
                anchorEl:"#tourAttestationsTable",
                element: document.getElementsByClassName("tourNewAttestationButton"),
                last: true,
            },
            // 4:{
            //     step: 4,
            //     title: "",
            //     content: "",
            //     scrollToElement: null,
            //     anchorEl: "",
            //     element: null,
            //     last: false,
            // },
        },
        style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // width: 400,
            // height: 250,
            background: 'white',
            borderRadius: "10px",
            // border: '1px solid #000',
            boxShadow: 24,
            p: 4,
            // zIndex: 1502,
        }
    }

export default BRBizInitialTourAttestation;